<template>
    <v-dialog
        v-model="abrir"
        max-width="650px" 
        scrollable
        persistent>
        <v-card>
        <v-card-title>
            <span class="headline">{{ titulo }} </span>
        </v-card-title>

        <v-card-text>
            <v-container>
                <v-layout rows wrap>
                    <v-flex md12>
                        <v-list dense v-for="(header, index) in headers"
                                :key="index + '-attribute'">
                            <v-list-tile v-if = "index%2!=0" class="fondolinea">
                                <v-list-tile-content pr-1 class="font-weight-black">{{ header.text }}</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{ datos[header.value] }} {{ header.suffix }}</v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-else>
                                <v-list-tile-content pr-1 class="font-weight-black">{{ header.text }}</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{ datos[header.value] }} {{ header.suffix }}</v-list-tile-content>
                            </v-list-tile>  
                            <v-divider/>
                        </v-list>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer/>
            <v-btn
            color="blue darken-1"
            text
            @click = "cerrar">Cerrar</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import ServiceHandler from '../../ServiceHandler';

export default {
    props: {
        datos: Object,
        headers: Array,
        abrir: Boolean,
        titulo: String
    },
    methods: {
        cerrar() {
            //this.abrir = false;
            this.$emit('cerrarVentana');
        },
    }
}
</script>
<style scoped>
    .fondolinea{
        background-color: #f7f2d8;
    }
</style>